// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_transcript__HJ6jM {
  display: flex;
  flex-direction: column;
  gap: 24px;
  position: relative;
}
.styles_transcript__HJ6jM .styles_singleSegment__vxYcO {
  display: flex;
  justify-content: flex-start;
  gap: 8px;
}
.styles_transcript__HJ6jM .styles_singleSegment__vxYcO .styles_counterMarker__Zyehd {
  margin-top: 8px;
  font-size: 12px;
  background-color: #6ba7a8;
  font-weight: 700;
  color: #fff;
  height: 30px;
  width: 30px;
  justify-content: center;
  align-items: center;
  display: flex;
  border-radius: 100%;
}
.styles_transcript__HJ6jM .styles_singleSegment__vxYcO .styles_counterMarker__Zyehd.styles_emptySpeaker__eLpaL {
  background-color: red;
}

.styles_contentWrapper__YKdvH {
  display: flex;
  flex-direction: column;
  gap: 2rem;
}
@media screen and (min-width: 992px) {
  .styles_contentWrapper__YKdvH {
    display: grid;
    grid-template-columns: repeat(10, 1fr);
    gap: 3rem;
  }
}
.styles_contentWrapper__YKdvH .styles_transcriptWrapper__mJ31L {
  order: 2;
}
@media screen and (min-width: 992px) {
  .styles_contentWrapper__YKdvH .styles_transcriptWrapper__mJ31L {
    grid-column: span 7;
    order: 1;
  }
}
.styles_contentWrapper__YKdvH .styles_sidebar__yYOnK {
  display: flex;
  flex-direction: column;
  gap: 24px;
  order: 1;
}
@media screen and (min-width: 992px) {
  .styles_contentWrapper__YKdvH .styles_sidebar__yYOnK {
    grid-column: span 3;
    order: 2;
  }
}

.styles_mediaWrapper__q58UM {
  background-color: #6ba7a8;
  padding: 8px;
  border-radius: 12px;
  z-index: 2;
  display: flex;
  box-shadow: rgba(0, 0, 0, 0.15) 1.95px 1.95px 2.6px;
}
.styles_mediaWrapper__q58UM .styles_mediaContainer__RcEC8 {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 12px;
  align-items: center;
}
.styles_mediaWrapper__q58UM .styles_mediaContainer__RcEC8 .styles_media__Hf4k\\+ {
  width: 100%;
}
.styles_mediaWrapper__q58UM .styles_mediaContainer__RcEC8 .styles_button__tjEkL {
  color: #fff;
  font-weight: 500;
  cursor: pointer;
  text-align: center;
}

.styles_searchReplacePanel__VyQ2X {
  display: flex;
  gap: 1rem;
  justify-content: space-between;
  align-items: center;
  padding: 0.5rem;
  background-color: #fff;
  border-radius: 12px;
  border: 1px solid #ddd;
  position: fixed;
  bottom: 0.5rem;
  left: 0.5rem;
  z-index: 1000;
  filter: drop-shadow(0px 0px 10px rgba(0, 0, 0, 0.1));
}

.styles_searchReplaceControls__UqXDm {
  display: flex;
  gap: 1rem;
}
.styles_searchReplaceControls__UqXDm input {
  padding: 0.5rem;
  border: 1px solid #ddd;
  border-radius: 4px;
  flex: 1 1;
}
.styles_searchReplaceControls__UqXDm button {
  padding: 0.5rem 1rem;
  background-color: #6ba7a8;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}
.styles_searchReplaceControls__UqXDm button:disabled {
  background-color: #ccc;
  cursor: not-allowed;
}
.styles_searchReplaceControls__UqXDm button:hover:not(:disabled) {
  background-color: #6ba7a8;
}

.styles_searchReplaceToggle__hFeHG {
  padding: 0.5rem;
  background-color: #f8f9fa;
  border: 1px solid #ddd;
  border-radius: 999px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}
.styles_searchReplaceToggle__hFeHG svg {
  width: 16px;
  height: 16px;
  color: #6ba7a8;
}
.styles_searchReplaceToggle__hFeHG:hover {
  background-color: #e9ecef;
}`, "",{"version":3,"sources":["webpack://./src/components/reusable/SingleTranscript/Transcript/styles.module.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,kBAAA;AACF;AACE;EACE,aAAA;EACA,2BAAA;EACA,QAAA;AACJ;AACI;EACE,eAAA;EACA,eAAA;EACA,yBAAA;EACA,gBAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;EACA,uBAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;AACN;AACM;EACE,qBAAA;AACR;;AAIA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AADF;AAEE;EAJF;IAKI,aAAA;IACA,sCAAA;IACA,SAAA;EACF;AACF;AACE;EACE,QAAA;AACJ;AAAI;EAFF;IAGI,mBAAA;IACA,QAAA;EAGJ;AACF;AAAE;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,QAAA;AAEJ;AADI;EALF;IAMI,mBAAA;IACA,QAAA;EAIJ;AACF;;AAAA;EACE,yBAAA;EACA,YAAA;EACA,mBAAA;EACA,UAAA;EACA,aAAA;EACA,mDAAA;AAGF;AAFE;EACE,WAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;EACA,mBAAA;AAIJ;AAHI;EACE,WAAA;AAKN;AAHI;EACE,WAAA;EACA,gBAAA;EACA,eAAA;EACA,kBAAA;AAKN;;AAGA;EACE,aAAA;EACA,SAAA;EACA,8BAAA;EACA,mBAAA;EACA,eAAA;EACA,sBAAA;EACA,mBAAA;EACA,sBAAA;EACA,eAAA;EACA,cAAA;EACA,YAAA;EACA,aAAA;EACA,oDAAA;AAAF;;AAGA;EACE,aAAA;EACA,SAAA;AAAF;AAEE;EACE,eAAA;EACA,sBAAA;EACA,kBAAA;EACA,SAAA;AAAJ;AAGE;EACE,oBAAA;EACA,yBAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;AADJ;AAGI;EACE,sBAAA;EACA,mBAAA;AADN;AAII;EACE,yBAAA;AAFN;;AAOA;EACE,eAAA;EACA,yBAAA;EACA,sBAAA;EACA,oBAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAJF;AAKE;EACE,WAAA;EACA,YAAA;EACA,cAAA;AAHJ;AAKE;EACE,yBAAA;AAHJ","sourcesContent":[".transcript {\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n  position: relative;\n\n  .singleSegment {\n    display: flex;\n    justify-content: flex-start;\n    gap: 8px;\n\n    .counterMarker {\n      margin-top: 8px;\n      font-size: 12px;\n      background-color: #6ba7a8;\n      font-weight: 700;\n      color: #fff;\n      height: 30px;\n      width: 30px;\n      justify-content: center;\n      align-items: center;\n      display: flex;\n      border-radius: 100%;\n\n      &.emptySpeaker {\n        background-color: red;\n      }\n    }\n  }\n}\n.contentWrapper {\n  display: flex;\n  flex-direction: column;\n  gap: 2rem;\n  @media screen and (min-width: 992px) {\n    display: grid;\n    grid-template-columns: repeat(10, 1fr);\n    gap: 3rem;\n  }\n\n  .transcriptWrapper {\n    order: 2;\n    @media screen and (min-width: 992px) {\n      grid-column: span 7;\n      order: 1;\n    }\n  }\n\n  .sidebar {\n    display: flex;\n    flex-direction: column;\n    gap: 24px;\n    order: 1;\n    @media screen and (min-width: 992px) {\n      grid-column: span 3;\n      order: 2;\n    }\n  }\n}\n\n.mediaWrapper {\n  background-color: #6ba7a8;\n  padding: 8px;\n  border-radius: 12px;\n  z-index: 2;\n  display: flex;\n  box-shadow: rgba(0, 0, 0, 0.15) 1.95px 1.95px 2.6px;\n  .mediaContainer {\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n    gap: 12px;\n    align-items: center;\n    .media {\n      width: 100%;\n    }\n    .button{\n      color: #fff;\n      font-weight: 500;\n      cursor: pointer;\n      text-align: center;\n    }\n  }\n  \n}\n\n// ... existing styles ...\n\n.searchReplacePanel {\n  display: flex;\n  gap: 1rem;\n  justify-content: space-between;\n  align-items: center;\n  padding: 0.5rem;\n  background-color: #fff;\n  border-radius: 12px;\n  border: 1px solid #ddd;\n  position: fixed;\n  bottom: 0.5rem;\n  left: 0.5rem;\n  z-index: 1000;\n  filter: drop-shadow(0px 0px 10px rgba(0, 0, 0, 0.1));\n}\n\n.searchReplaceControls {\n  display: flex;\n  gap: 1rem;\n  \n  input {\n    padding: 0.5rem;\n    border: 1px solid #ddd;\n    border-radius: 4px;\n    flex: 1;\n  }\n  \n  button {\n    padding: 0.5rem 1rem;\n    background-color: #6ba7a8;\n    color: white;\n    border: none;\n    border-radius: 4px;\n    cursor: pointer;\n    \n    &:disabled {\n      background-color: #ccc;\n      cursor: not-allowed;\n    }\n    \n    &:hover:not(:disabled) {\n      background-color: #6ba7a8;\n    }\n  }\n}\n\n.searchReplaceToggle {\n  padding: 0.5rem;\n  background-color: #f8f9fa;\n  border: 1px solid #ddd;\n  border-radius: 999px;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  svg{\n    width: 16px;\n    height: 16px;\n    color: #6ba7a8;\n  }\n  &:hover {\n    background-color: #e9ecef;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"transcript": `styles_transcript__HJ6jM`,
	"singleSegment": `styles_singleSegment__vxYcO`,
	"counterMarker": `styles_counterMarker__Zyehd`,
	"emptySpeaker": `styles_emptySpeaker__eLpaL`,
	"contentWrapper": `styles_contentWrapper__YKdvH`,
	"transcriptWrapper": `styles_transcriptWrapper__mJ31L`,
	"sidebar": `styles_sidebar__yYOnK`,
	"mediaWrapper": `styles_mediaWrapper__q58UM`,
	"mediaContainer": `styles_mediaContainer__RcEC8`,
	"media": `styles_media__Hf4k+`,
	"button": `styles_button__tjEkL`,
	"searchReplacePanel": `styles_searchReplacePanel__VyQ2X`,
	"searchReplaceControls": `styles_searchReplaceControls__UqXDm`,
	"searchReplaceToggle": `styles_searchReplaceToggle__hFeHG`
};
export default ___CSS_LOADER_EXPORT___;
